import { checkMarketAu } from "./helpers";

export const settingsFieldName = [
  {
    value: "all",
    textField: "All"
  },
  {
    value: "defaultInterestRate",
    textField: "Default Interest Rate"
  },
  {
    value: "dealerOriginationFees",
    textField: "Dealer Origination Fees"
  },
  {
    value: "ppsr",
    textField: "PPSR"
  },
  {
    value: "establishmentFee",
    textField: "Establishment Fee"
  },
  {
    value: "accountKeepingFee",
    textField: "Account Keeping Fee"
  },
  {
    value: "annualKmAllowance",
    textField: "Annual km Allowance"
  }
];
